import { toast as sonnerToast } from 'sonner';

// Drop-in replacement for react-toastify's toast API.
// All existing toast.success() / toast.error() calls work unchanged.
export const toast = {
    success: (message, options) => sonnerToast.success(message, options),
    error: (message, options) => sonnerToast.error(message, options),
    info: (message, options) => sonnerToast.info(message, options),
    warning: (message, options) => sonnerToast.warning(message, options),
    warn: (message, options) => sonnerToast.warning(message, options),
};
